import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { obtenerDiasPorEvento, reporteCortesias } from "../../../../service/cortesias/cortesias";
import { ReporteCortesiasModel } from "../models/ReporteModel";
import { SelectFormat } from "../../../../../rbts/helpers/models/GenericModel";

export const useReporteCortesias = (realoadGrid: number, id_dia: number) => {

  const [list, setList] = useState<ReporteCortesiasModel[]>([]);
  const [saldoElectronico, setSaldoElectronico] = useState<number>(0);
  const [loadingRequest, setLoadingRequest] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await reporteCortesias(id_dia)
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res.cortesias.rows);
        setSaldoElectronico(res.saldo_electronico);
        setLoadingRequest(false);
      }
    };
    if(id_dia > 0){
      fetchPost();
    }else{
      setLoadingRequest(false);
      setList([]);
    }

  }, [realoadGrid, id_dia]);

  return { list, saldoElectronico, loadingRequest };
};

export const useObtenerDiasPorEvento = (reload: number) => {
  const [list, setList] = useState<SelectFormat[]>([]);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(true);
  const history = useHistory();

  useEffect(() => {
    const fetchPost = async () => {
      const res = await obtenerDiasPorEvento()
        .then()
        .catch((error) => {
          history.push("/error/500");
        });
      if (res) {
        setList(res);
        setLoadingRequest(false);
      }
    };
    fetchPost();
  }, [reload]);

  return { list, loadingRequest };
};
